import { Report } from '@root/logger';

// https://segmentfault.com/a/1190000023259434
// https://qa.1r1g.com/sf/ask/3137062071/
// https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
window.addEventListener('error', (e: ErrorEvent) => {
  try {
    const isScriptError = /Script error/.test(e.message);
    if (isScriptError) {
      return; // 外站脚本报错, 自动化测试
    }
    let event = 'unknown';
    const isChunkLoadFailed = /Loading chunk [\d]+ failed/.test(e.message);
    if (isChunkLoadFailed) {
      event = 'chunk';
    }
    Report.upload({
      module: 'WindowError',
      level: 'error',
      event,
      message: e.message,
      error: e.error,
    });
  } catch (error) {
    // do sth
  }
});

// https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  try {
    Report.upload({
      module: 'PromiseError',
      level: 'error',
      event: 'unhandledrejection',
      message: e.reason,
    });
  } catch (error) {
    // do sth
  }
});
